export const SHOW_CREATE_GROUP_MODAL_SENTINEL =
  'SHOW_CREATE_GROUP_MODAL_SENTINEL';
